import { axiosPrivate } from './config';

const useSettingApi = () => {
    const createSetting = (data) => {
        return axiosPrivate.post('/order', data).then((res) => res.data);
    };

    const getSettings = () => {
        return axiosPrivate.get(`/setting/get-settings`).then((res) => res.data);
    };
    return { createSetting, getSettings };
};


export default useSettingApi;